export const GET_LIST_KHIEU_NAI = 'GET_LIST_KHIEU_LAI';
export const GET_LIST_KHIEU_NAI_DONE = 'GET_LIST_KHIEU_LAI_DONE';

export const CREATE_KHIEU_NAI = 'CREATE_KHIEU_NAI';

export const GET_CHI_TIET_KHIEU_NAI = 'GET_CHI_TIET_KHIEU_NAI';
export const DONG_KHIEU_NAI = 'DONG_KHIEU_NAI';
export const PHAN_HOI_KHIEU_NAI = 'PHAN_HOI_KHIEU_NAI';
export const CAP_NHAT_KHIEU_NAI = 'CAP_NHAT_KHIEU_NAI';
export const GET_LIST_KHIEU_NAI_THEO_USER = 'GET_LIST_KHIEU_NAI_THEO_USER';
export const GET_LIST_KHIEU_NAI_THEO_USER_DONE = 'GET_LIST_KHIEU_NAI_THEO_USER_DONE';